import { useNavigation } from "@/providers";
import { RobotoButton } from "@/shared/components";
import { EntityIcon } from "@/shared/foundation/icons";

interface CreateDatasetEventProps {
  datasetId: string;
}

export function CreateDatasetEvent({ datasetId }: CreateDatasetEventProps) {
  const { goto } = useNavigation();
  return (
    <RobotoButton
      eventName={"CreateDatasetEventClicked"}
      eventProperties={{ datasetId }}
      onClick={() => goto.createDatasetEvent({ datasetId })}
      size="small"
      startIcon={<EntityIcon type="event" size={18} />}
      variant="outlined"
    >
      Create Event
    </RobotoButton>
  );
}
